$(document).ready(function(){
    $('#sliderBanner').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: false,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear',
        lazyLoad: 'ondemand',
    });
});
